module.exports = __webpack_public_path__ + "img/valencia-edwards.f5bb222b.png";